import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';
import deepmerge from 'deepmerge';

import useNotification from '../../../core/hooks/use_notification';
import { getDefaultPaginationQueryValues } from '../../../core/utils/api_utils';
import PaginationControls from '../../common/pagination_controls';
import { Button } from '../../common/button';
import { getProducersAction, getProducersState } from '../../../features/product/get_producers';
import { getProducersNotificationData } from '../../../core/utils/notification_utils';
import { ROUTE_PRODUCER_FORMS_NEW } from '../../../core/constants';
import ProducerFilters from './filters';
import ProducersList from './producers_list';
import PageHeader from '../../common/page_header';

const initialQueryParams = {
    ...getDefaultPaginationQueryValues,
    query: ''
};

const ProducersPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showErrorMessage } = useNotification();

    const getProducers = useSelector(getProducersState);

    const [queryParams, setQueryParams] = useState(initialQueryParams);

    const refreshList = useCallback(() => {
        dispatch(getProducersAction(queryParams))
            .then(response => showErrorMessage(getProducersNotificationData(response)));
    }, [dispatch, queryParams, showErrorMessage]);

    useEffect(() => {
        refreshList();
    }, [dispatch, queryParams, refreshList, showErrorMessage]);

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>

            <PageHeader
                title="Producenci"
                actions={
                    <Button onClick={ () => navigate(ROUTE_PRODUCER_FORMS_NEW) }>
                        Dodaj producenta
                    </Button>
                }
            />

            <ProducerFilters
                onClear={ () => setQueryParams(prevState => deepmerge(prevState, { query: '' })) }
                onSearchInputChange={ query => setQueryParams(prevState => deepmerge(prevState, { query })) }
            />

            {
                getProducers?.loading &&
                <Box sx={ { width: '100%' } }>
                    <LinearProgress/>
                </Box>
            }

            {
                getProducers?.data?.content &&
                <Box sx={ { display: 'flex', flexDirection: 'column', gap: 2 } }>
                    <ProducersList refreshList={ refreshList }/>

                    <Box sx={ { display: 'flex', justifyContent: 'flex-end', mt: 1 } }>
                        <PaginationControls
                            currentPage={ getProducers?.data?.pageable?.pageNumber }
                            totalPages={ getProducers?.data?.totalPages }
                            setPage={ page => setQueryParams(prevState => deepmerge(prevState, { page })) }
                        />
                    </Box>
                </Box>
            }
        </Box>
    );
};

export default ProducersPage;